import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { ShortRevenueName } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/revenueCommon/shortRevenueName/ShortRevenueName'
import { ShortYearRevenue } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/revenueCommon/shortYearRevenue/ShortYearRevenue'
import { ShortYoYRevenue } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/revenueCommon/shortYoYRevenue/ShortYoYRevenue'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getFieldByActualsValueType } from '../../../helpers/getFieldByActualsValueType'
import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { IColumn } from '../../styledComponents/styledTable/types'

import { getCurrentYearThView, getPrevYearThView, getTwoYearsAgoThView } from './getDynamicThView'

interface IProps {
  onChange: (field: string, keyValue: string) => (value: string | number) => void
  currentYear: number
  currentQuarter: number
  netNdpValue: ActualsValueTypes
  onlyCurrentAndPrevYear?: boolean
}

export const getRevenueShortViewColumns = ({
  currentYear,
  currentQuarter,
  netNdpValue,
  onChange,
  onlyCurrentAndPrevYear,
}: IProps): IColumn<IRevenue>[] => {
  const previousYearField = getFieldByActualsValueType<IRevenue>('PreviousYearRevenue', netNdpValue)
  const currentYearField = getFieldByActualsValueType<IRevenue>('CurrentYearRevenue', netNdpValue)
  const twoYearsAgoField = getFieldByActualsValueType<IRevenue>('TwoYearsAgo', netNdpValue)
  const yoyField = getFieldByActualsValueType<IRevenue>('YoY', netNdpValue)

  const commonColumns: IColumn<IRevenue>[] = [
    {
      title: getFormedEltTranslation('revenue-table-revenue'),
      field: 'Name',
      renderComponent: ({ value, keyValue }) => (
        <ShortRevenueName
          value={value || ''}
          keyValue={keyValue}
          isSubCategory={keyValue === 'PolyByMarketsTotal'}
        />
      ),
    },
    {
      field: previousYearField,
      titleRenderFn: () => getPrevYearThView(currentYear),
      renderComponent: ({ value, keyValue }) => (
        <ShortYearRevenue
          value={value || ''}
          keyValue={keyValue}
          field={previousYearField}
          onChange={onChange}
        />
      ),
    },
    {
      field: currentYearField,
      titleRenderFn: () => getCurrentYearThView(currentYear, currentQuarter),
      renderComponent: ({ value, keyValue }) => (
        <ShortYearRevenue
          value={value || ''}
          keyValue={keyValue}
          field={currentYearField}
          onChange={onChange}
        />
      ),
    },
    {
      title: getFormedEltTranslation('revenue-table-yoy-short'),
      field: yoyField,
      renderComponent: ({ value, keyValue }) => {
        return <ShortYoYRevenue value={value} keyValue={keyValue} />
      },
    },
  ]

  const twoYearsAgoColumn: IColumn<IRevenue> = {
    titleRenderFn: () => getTwoYearsAgoThView(currentYear),
    field: twoYearsAgoField,
    renderComponent: ({ value, keyValue }) => (
      <ShortYearRevenue
        value={value || ''}
        keyValue={keyValue}
        field={twoYearsAgoField}
        onChange={onChange}
      />
    ),
  }

  if (onlyCurrentAndPrevYear) {
    return commonColumns
  }

  return [commonColumns[0], twoYearsAgoColumn, ...commonColumns.slice(1)]
}
